import { TSID_MIGRATED_COOKIE_PREFIX } from 'config/cookie';
import { getEnvironment } from 'utils/route';
import { cookiesInstance } from './cookiesInstance';

const getCookieName = () => `${TSID_MIGRATED_COOKIE_PREFIX}_${getEnvironment()}`;

export const set = (value: string) => cookiesInstance.set(getCookieName(), value);

export const get = (): string | undefined => {
  return cookiesInstance.get(getCookieName());
};

export const remove = () => cookiesInstance.remove(getCookieName());
